import ImeiCheckPage from '@/modules/imei-check-page/imei-check-page';
import { AttemptsData } from '@/modules/loading-page/types';
import SeoHead from '@/shared/components/seo-head/seo-head';
import { getServerLimitData } from '@/utils/helpers/get-server-limit-data';
import pick from '@/utils/translation/pick';
import { GetServerSidePropsContext } from 'next';

import { useTranslations } from 'next-intl';

const linksList = [
  { href: '/samsung-imei-check', title: 'Samsung' },
  { href: '/imei-check/samsung-tablet', title: 'Samsung Tablet' },
  { href: '/imei-check/samsung-galaxy-watch', title: 'Samsung Galaxy Watch' },
  { href: '/imei-check/google-pixel', title: 'Google Pixel' },
  { href: '/imei-check/xiaomi', title: 'Xiaomi' },
  { href: '/imei-check/motorola', title: 'Motorola' },
];

const LenovoLaptop = ({ limitData }: { limitData: AttemptsData }) => {
  const t = useTranslations('LenovoLaptop');

  return (
    <>
      <SeoHead title={t('metaTitle')} description={t('metaDescription')} />
      <div className="gradient full-height">
        <ImeiCheckPage
          title={t('title')}
          text={t('text')}
          t={t}
          limitData={limitData}
          links={linksList}
        />
      </div>
    </>
  );
};

export default LenovoLaptop;

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  const limitData = await getServerLimitData();

  return {
    props: {
      limitData,
      messages: pick((await import(`src/intl/${locale}.js`)).default, [
        'Common',
        'LenovoLaptop',
      ]),
    },
  };
}
